import * as React from 'react';
import ReactSignatureCanvas from 'react-signature-canvas';

export interface ISignatureCanvasProps {
    id: string;
    label: string;
    value: string;
    isRequired: boolean;
    className?: string;
    onChange: (id: string, value: string) => void;
}

export const SignatureCanvasComponent: React.FC<ISignatureCanvasProps> = ({
    id,
    label,
    value,
    isRequired = false,
    className = '',
    onChange
}) => {
    const sigCanvasRef = React.useRef<ReactSignatureCanvas>(null);

    const clearSignature = () => {
        sigCanvasRef.current?.clear();
        onChange(id, '');
        setTimeout(() => {
            document.dispatchEvent(new Event('signatureSaved'));
        }, 100);
    };

    const saveSignature = () => {
        if (sigCanvasRef.current) {
            const base64Data = sigCanvasRef.current.getTrimmedCanvas().toDataURL('image/png');
            onChange(id, base64Data);

            setTimeout(() => {
                document.dispatchEvent(new Event('signatureSaved'));
            }, 100);
        }
    };

    return (
        <div className={`signature-canvas-wrapper ${className}`}>
            <div className='signature-canvas-container'>
                <ReactSignatureCanvas
                    ref={sigCanvasRef}
                    penColor='black'
                    canvasProps={{
                        id,
                        className: 'signature-canvas',
                        width: 500,
                        height: 200
                    }}
                />
            </div>
            <div className='signature-canvas-actions'>
                <button type='button' onClick={clearSignature}>
                    Clear Signature
                </button>
                <button
                    type='button'
                    onClick={() => {
                        saveSignature();
                    }}
                >
                    Save Signature
                </button>
            </div>
        </div>
    );
};

export default SignatureCanvasComponent;
